module.exports = __webpack_public_path__ + "static/media/Follower_Button-22.208d7a7d.png";